module.exports = __webpack_public_path__ + "img/joinCurveWhite.f6493f41.svg";